import React, { Component } from "react";
import { Row, Col, Tabs, Icon, Tooltip } from "antd";
import history from "../../../../../history/history";
import { selectHeader } from "../../../../../actions/globalActions";
import moment from "moment";
import queryString from "query-string";
import "moment-timezone";
import { connect } from "react-redux";
import _ from "lodash";
import { AccountCardComponent } from "../CardComponent/CardComponent";
import {
  initiateTracking,
  formatShares,
  formatSharesWithSixDecimal,
  recordError
} from "../../../../../utils/commonUtil";
import grantagreement from "../../../../../assets/icons/grant-agreement.svg";
import "./Tabs.css";
import loader from "../../../../../assets/icons/loader.gif";
import {
  TabFooter,
  NotifyText
} from "../../../../../CommonComponents/commonStyles";
import PurposeSummary from "../../../../Grants/Components/PurposeSummary/PurposeSummary";
import { PropTypes } from 'prop-types';
import { accountSummaryDerivedStates } from "../../selectors";

export function getMilliseconds(date) {
  return parseInt(moment(date).format("x"));
}

export function displayEnteredBy(data) {
  let userName = null;
  // DP User
  if (data["csrFlow"] == false && data["csrDPFlow"] == false) {
    if (data["enteredDate"] > getMilliseconds("05/01/2009")) {
      userName = `${data["dpUserPrefix"] ? data["dpUserPrefix"] + " " : ""}${
        data["dpUserFirstName"] ? data["dpUserFirstName"] + " " : ""
      }${data["dpUserMiddleName"] ? data["dpUserMiddleName"] + " " : ""}${
        data["dpUserLastName"] ? data["dpUserLastName"] + " " : ""
      }${data["dpUserSuffix"] ? data["dpUserSuffix"] + " " : ""}`;
    }
  } // Gemini user
  else if (data["csrFlow"] == true && data["csrDPFlow"] == false) {
    if (data["enteredDate"] > getMilliseconds("05/01/2009")) {
      userName = `${data["dpUserPrefix"] ? data["dpUserPrefix"] + " " : ""}${
        data["dpUserFirstName"] ? data["dpUserFirstName"] + " " : ""
      }${data["dpUserMiddleName"] ? data["dpUserMiddleName"] + " " : ""}${
        data["dpUserLastName"] ? data["dpUserLastName"] + " " : ""
      }${data["dpUserSuffix"] ? data["dpUserSuffix"] + " " : ""}`;
    }
  }
  return (data["csrFlow"] !== false && data["csrDPFlow"] !== true) ||
    userName !== null ? (
    <Col md={{ span: 8 }} xs={{ span: 12 }}>
      <b className="font-normal">Entered By</b>
      <h6 className="font-bold">{userName}</h6>
    </Col>
  ) : null;
}

export class TableTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabsDataCalled: true,
      exchangeLength: "",
      grantsLength: "",
      contributionLength: "",
      otherTransactionLength: "",
      isgrantsLoading: true,
      isContributionLoading: true,
      isExchangeLoading: true,
      isOtherTransactionLoading: true,
      threeMonthContribData: [],
      threeMonthGrantsData: [],
      threeMonthExchangeData: [],
      threeMonthOtherData: [],
      tabSelectedValue: "1"
    };
    this.navigateToCA = this.navigateToCA.bind(this);
    this.navigateViewContribution = this.navigateViewContribution.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.isInvestmentLoading === false &&
      nextProps.isGrantLoading === false &&
      nextProps.isContributionLoading === false &&
      nextProps.isOtherTransactionLoading === false
    ) {
      this.tabsLength(nextProps);
    }
  }

  tabsLength(Props) {
    let d = moment()
      .subtract(90, "days")
      .format("x");

    let threeMonthContribData = Props.contribution;

    let threeMonthGrantsData = _.filter(Props.grant_data, function(o) {
      return o && o.dateRequested >= d;
    });

    let threeMonthExchangeData = _.filter(Props.investmentData, function(o) {
      return o && o.enteredDate >= d;
    });

    let threeMonthOtherData = _.filter(Props.otherTransaction_data, function(
      o
    ) {
      return o && o.enteredDate >= d;
    });

    this.setState({
      threeMonthContribData,
      threeMonthGrantsData,
      threeMonthExchangeData,
      threeMonthOtherData,
      isgrantsLoading: Props.isGrantLoading,
      isContributionLoading: Props.isContributionLoading,
      isExchangeLoading: Props.isInvestmentLoading,
      isOtherTransactionLoading: Props.isOtherTransactionLoading
    });
  }

  timeZoneConvertion(dataInMillisecond) {
    if (dataInMillisecond) {
      let estDate = moment.tz(dataInMillisecond, "America/New_York");
      return estDate;
    }
    return null;
  }

  navigateViewContribution(data) {
    try {
      this.props.selectHeader("Contribution Activity");
      history.push({
        pathname: "/contributions/activity/view",
        state: {
          transactionId: data.txnId,
          status: data.status,
          giftId: data.giftId
        }
      });
    } catch (error) {
      recordError(error);
    }
  }

  navigateToCA() {
    try {
      this.props.selectHeader("Contribution Activity");
      history.push("/contributions/activity");
    } catch (error) {
      recordError(error);
    }
  }

  navigateToTxn = tab => {
    try {
      if (tab) {
        this.props.selectHeader("MY ACCOUNT");
        history.push("/my-account/transaction-summary?tab=otherTransactions");
      } else {
        this.props.selectHeader("MY ACCOUNT");
        history.push("/my-account/transaction-summary");
      }
    } catch (error) {
      recordError(error);
    }
  };

  navigateToExcahngeActivity = () => {
    try {
      this.props.selectHeader("Exchange Activity");
      history.push("./investments/exchange-activity");
    } catch (error) {
      recordError(error);
    }
  };

  navigateToGrantActivity = () => {
    try {
      this.props.selectHeader("Grant Activity");
      history.push("/grants/activity");
    } catch (error) {
      recordError(error);
    }
  };

  selectedTabs = e => {
    let tabSelected = "";
    switch (e) {
      case "1":
        tabSelected = "Grants";
        break;
      case "2":
        tabSelected = "Contributions";
        break;
      case "3":
        tabSelected = "Exchanges";
        break;
      case "4":
        tabSelected = "Other Transactions";
        break;
    }
    {
      this.setState({
        tabSelectedValue: e
      });
    }
    return tabSelected;
  };

  tabsHandler = e => {
    if (this.state.tabSelectedValue !== e) {
      initiateTracking("tabClick", "Account Summary", "", this.selectedTabs(e));
    } else {
    }
  };

  viewExchangeTxn = (e, data) => {
    try {
      this.props.selectHeader("Exchange Activity");
      e.stopPropagation();
      switch (data.exchangetype) {
        case "From TIFF":
          history.push({
            pathname: `/view-edit-tiff-from/${data.txnId}/view`
          });
          break;
        case "To TIFF":
          history.push({
            pathname: `/view-edit-tiff-into/${data.txnId}/view`
          });
          break;
        default:
          history.push({
            pathname: `/investments/recommend-an-exchange/${data.txnId}`,
            search: `type=onetime`,
            state: { txn: data, page: "edit" }
          });
          break;
      }
    } catch (error) {
      recordError(error);
    }
  };

  viewGrantsTxn = (id, agreement, checkClearedDate) => {
    try {
      this.props.selectHeader("Grant Activity");
      let url = `/grants/activity/view`;
      if (agreement) {
        url = `/grants/grant-agreement/view`;
        history.push(`${url}?grantId=${id}`);
      } else {
        history.push({
          pathname: url,
          search:queryString.stringify({ grantId:id }),
          state: { checkClearedDate }
        });
      }
    } catch (error) {
      recordError(error);
    }
  };

  viewOtherTransaction = (id) => {
    try {
      history.push({
        pathname: "/my-account/other-transaction",
        state: {
          transactionId: id,
        }
      });
    } catch (error) {
      recordError(error);
    }
  };

  render() {
    const TabPane = Tabs.TabPane;
    const {
      threeMonthContribData,
      threeMonthGrantsData,
      threeMonthExchangeData,
      threeMonthOtherData
    } = this.state;
    return (
      <div>
        <Tabs defaultActiveKey="1" type="card" onTabClick={this.tabsHandler}>
          <TabPane tab={<div tabindex="0">Grants</div>} key="1">
            {this.state.isgrantsLoading === true ? (
              <div>
                <div className="loader-position">
                  {this.props.isGrantLoading}
                  <div>
                    <img alt="Loader" src={loader} className="mr-icon" />
                  </div>
                </div>
              </div>
            ) : threeMonthGrantsData.length !== 0 ? (
              <div>
                <div className="table-fixed-link ac-link-navigator">
                  <TabFooter>
                    <a
                      onClick={() => {
                        this.navigateToGrantActivity();
                      }}
                      className="link-navigator tool-tip"
                      tabindex="0"
                      data-test="grantActivity-click-btn"
                    >
                      <span>VIEW GRANT ACTIVITY</span>{" "}
                      <span className="new_arrow">
                        <span className="arrow_line">
                          <span></span>
                        </span>
                      </span>
                    </a>
                    <NotifyText noMargin>
                      Transactions displayed above are from last 90 days
                    </NotifyText>
                  </TabFooter>
                </div>
                {threeMonthGrantsData.map((data, i) => {
                  let issuedate = moment(
                    this.timeZoneConvertion(data.issuedate)
                  ).format("L");
                  let dateRequested = moment(
                    this.timeZoneConvertion(data.dateRequested)
                  ).format("L");
                  return (
                    <AccountCardComponent key={i}>
                      <Row>
                        <Col md={{ span: 24 }} xs={{ span: 24 }}>
                          <h6 className="transaction-id">
                            <a
                              data-test="viewGrantsTxn-click-btn"
                              onClick={() =>
                                this.viewGrantsTxn(
                                  data.txnId,
                                  data.grantAgreement,
                                  data.checkClearedDate
                                )
                              }
                            >
                              {" "}
                              Transaction Id:{data.txnId}{" "}
                            </a>{" "}
                            <span> </span>
                          </h6>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={{ span: 24 }}>
                          <h6 className="font-normal">{data.charityName}</h6>
                        </Col>
                      </Row>

                      <Row className="main-data">
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Date Requested</b>
                          <h6 className="font-bold">{dateRequested}</h6>
                        </Col>
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Issue Date</b>
                          <h6 className="font-bold">
                            {issuedate == "Invalid date" ? (
                              "-"
                            ) : (
                              <div> {issuedate}</div>
                            )}
                          </h6>
                        </Col>
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Interest Area</b>
                          <h6 className="font-bold">{data.interestArea}</h6>
                        </Col>

                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Purpose</b>
                          <div>
                            <Tooltip
                              className="grantsFlow"
                              placement="bottomLeft"
                              title={() => <PurposeSummary {...data.purpose} />}
                            >
                              <h6
                                className={`font-bold underl-line
                              }`}
                              >
                                {data.purpose.description}
                              </h6>
                            </Tooltip>
                          </div>
                        </Col>

                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Amount</b>
                          <h6 className="font-bold">
                            {!data.amount || data.amount == 0 ? (
                              "-"
                            ) : (
                              <div>
                                {"$" +
                                  parseFloat(data.amount).toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  )}
                              </div>
                            )}
                          </h6>
                        </Col>
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Status</b>
                          <h6 className="font-bold">{data.status}</h6>
                        </Col>

                        {displayEnteredBy(data)}
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Recurring</b>
                          <h6 className="font-bold">
                            {data.isRecurring == "false" ? (
                              "-"
                            ) : (
                              <div>
                                {" "}
                                <Icon type="sync" />
                              </div>
                            )}
                          </h6>
                        </Col>
                        <Col
                          md={{ span: 8 }}
                          xs={{ span: 12 }}
                          className={!data.grantAgreement ? "hide" : "show"}
                        >
                          <b className="font-normal">Grant Agreement</b>

                          <h6 className="font-bold">
                            <img
                              src={grantagreement}
                              className="mr-icon-grant-agreement"
                              alt="grant agreement"
                            />
                          </h6>
                        </Col>
                        <Col
                          md={{ span: 8 }}
                          xs={{ span: 12 }}
                          className={!data.grantAgreement ? "hide" : "show"}
                        >
                          <b className="font-normal" />
                          <h6 className="font-bold" />
                        </Col>
                      </Row>
                    </AccountCardComponent>
                  );
                })}
              </div>
            ) : (
              <div className="noDataPlacement">
                <div>No grants have been made in the last 90 days.</div>
              </div>
            )}
          </TabPane>

          <TabPane tab={<div tabindex="0">Contributions</div>} key="2">
            {this.state.isContributionLoading == true ? (
              <div className="loader-position">
                <div>
                  <img alt="Loader" src={loader} className="mr-icon" />
                </div>
              </div>
            ) : threeMonthContribData.length !== 0 ? (
              <div>
                <div
                  data-test="CA-click-btn"
                  onClick={() => this.navigateToCA()}
                  className="table-fixed-link ac-link-navigator"
                >
                  <TabFooter>
                    <a className="link-navigator tool-tip" tabindex="0">
                      {" "}
                      <span>VIEW CONTRIBUTION ACTIVITY </span>
                      <span className="new_arrow">
                        <span className="arrow_line">
                          <span></span>
                        </span>
                      </span>
                    </a>
                    <NotifyText noMargin>
                      Transactions displayed above are from last 90 days
                    </NotifyText>
                  </TabFooter>
                </div>

                {threeMonthContribData.map(data => {
                  let enteredDate = moment(
                    this.timeZoneConvertion(data.enteredDate)
                  ).format("L");
                  let receivedDate = moment(
                    this.timeZoneConvertion(data.receivedDate)
                  ).format("L");
                  let settledDate = moment(
                    this.timeZoneConvertion(data.settledDate)
                  ).format("L");
                  return (
                    <AccountCardComponent>
                      <Row>
                        <Col md={{ span: 24 }} xs={{ span: 24 }}>
                          <h6
                            data-test="navigateViewContribution"
                            onClick={() => this.navigateViewContribution(data)}
                            className={
                              data.reversed
                                ? "transaction-id-rev"
                                : "transaction-id"
                            }
                          >
                            <a> Transaction Id:{data.txnId}</a>

                            <span className="tool-tip">
                              <span className="alert-icon">
                                <Icon
                                  className={
                                    data.pendingContribution == false
                                      ? "hide"
                                      : "show"
                                  }
                                  type="warning"
                                />
                              </span>
                              <span>
                                <span class="tooltiptext-i">
                                  This pending transaction requires attention
                                </span>
                              </span>
                            </span>
                          </h6>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={{ span: 24 }}>
                          <h6 className="font-normal">{data.description}</h6>
                        </Col>
                      </Row>
                      <Row className="main-data">
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Entered By</b>
                          <h6 className="font-bold">
                            {data.dpUserPrefix ||
                            data.dpUserFirstName ||
                            data.dpUserMiddleName ||
                            data.dpUserLastName ||
                            data.dpUserSuffix ? (
                              <div>
                                {data.dpUserPrefix} {data.dpUserFirstName} {""}
                                {data.dpUserMiddleName} {""}
                                {data.dpUserLastName} {""}
                                {data.dpUserSuffix} {""}
                              </div>
                            ) : (
                              <div>{"-"}</div>
                            )}
                          </h6>
                        </Col>
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Entered Date</b>
                          <h6 className="font-bold">
                            {enteredDate == "Invalid date" ? (
                              "-"
                            ) : (
                              <div> {enteredDate}</div>
                            )}
                          </h6>
                        </Col>
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Contribution Type</b>
                          <h6 className="font-bold">{data.type}</h6>
                        </Col>

                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Status</b>
                          <h6 className="font-bold">{data.status}</h6>
                        </Col>

                        <Col
                          className={
                            settledDate === "Invalid date" ? "hide" : "show"
                          }
                          md={{ span: 8 }}
                          xs={{ span: 12 }}
                        >
                          <b className="font-normal">Settled Date</b>
                          <h6 className="font-bold">
                            {settledDate == "Invalid date" ? (
                              "-"
                            ) : (
                              <div> {settledDate}</div>
                            )}
                          </h6>
                        </Col>
                        <Col
                          md={{ span: 8 }}
                          xs={{ span: 12 }}
                          div
                          className={
                            (data.noOfShares == 0 || data.noOfShares == null) &&
                            !data.allShares
                              ? "hide"
                              : "show"
                          }
                        >
                          <b className="font-normal">Number of Shares</b>
                          <h6 className="font-bold">
                            {data.noOfShares == null ? (
                              "-"
                            ) : (
                              <div>
                                {!data.allShares ? (
                                  data.type === "Special Asset" ? (
                                    <>
                                      {formatSharesWithSixDecimal(
                                        data.noOfShares
                                      )}
                                    </>
                                  ) : (
                                    <>{formatShares(data.noOfShares)}</>
                                  )
                                ) : (
                                  <>{"All Shares"}</>
                                )}
                              </div>
                            )}
                          </h6>
                        </Col>
                        <Col
                          md={{ span: 8 }}
                          xs={{ span: 12 }}
                          className={data.amount == 0 ? "hide" : "show"}
                        >
                          <b className="font-normal">Amount</b>
                          <h6 className="font-bold">
                            {!data.amount || data.amount == 0 ? (
                              "-"
                            ) : data.status === "Reversed" ? (
                              <div>
                                {"$" +
                                  "(" +
                                  parseFloat(
                                    Math.abs(data.amount)
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  }) +
                                  ")"}
                              </div>
                            ) : (
                              <div>
                                {"$" +
                                  parseFloat(
                                    Math.abs(data.amount)
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })}
                              </div>
                            )}
                          </h6>
                        </Col>
                        <Col
                          md={{ span: 8 }}
                          xs={{ span: 12 }}
                          className={
                            data.amount == 0 &&
                            (data.noOfShares == 0 && data.noOfShares == null)
                              ? "show"
                              : "hide"
                          }
                        >
                          <b className="font-normal" />
                          <h6 className="font-bold" />
                        </Col>
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal" />
                          <h6 className="font-bold">{}</h6>
                        </Col>
                      </Row>
                    </AccountCardComponent>
                  );
                })}
              </div>
            ) : (
              <div className="noDataPlacement">
                <div>No contributions have been made in the last 90 days.</div>
              </div>
            )}
          </TabPane>
          <TabPane tab={<div tabindex="0">Exchanges</div>} key="3">
            {this.state.isExchangeLoading == true ? (
              <div className="loader-position">
                <div>
                  <img alt="Loader" src={loader} className="mr-icon" />
                </div>
              </div>
            ) : threeMonthExchangeData.length !== 0 ? (
              <div>
                <div className="table-fixed-link ac-link-navigator">
                  <TabFooter>
                    <a
                      data-test="ExchangeActivity-click-btn"
                      onClick={() => this.navigateToExcahngeActivity()}
                      className="link-navigator tool-tip"
                      tabindex="0"
                    >
                      {" "}
                      <span>VIEW EXCHANGE ACTIVITY </span>
                      <span className="new_arrow">
                        <span className="arrow_line">
                          <span></span>
                        </span>
                      </span>
                    </a>
                    <NotifyText noMargin>
                      Transactions displayed above are from last 90 days
                    </NotifyText>
                  </TabFooter>
                </div>
                {threeMonthExchangeData.map(data => {
                  let enteredDate = moment(
                    this.timeZoneConvertion(data.enteredDate)
                  ).format("L");
                  let tradeDate = moment(
                    this.timeZoneConvertion(data.tradeDate)
                  ).format("L");
                  return (
                    <AccountCardComponent>
                      <Row>
                        <Col md={{ span: 24 }} xs={{ span: 24 }}>
                          <h6 className="transaction-id">
                            <a
                              data-test="viewExchangeTxn"
                              className={ data.exchangetype.includes("Low Carbon Global Equity") 
                              ? "transaction-id-lcp"                              
                              : data.reversedExchange
                                  ? "transaction-id-rev"
                                  : "transaction-id"
                              }
                              onClick={ data.exchangetype.includes("Low Carbon Global Equity") 
                                ? '' : e => this.viewExchangeTxn(e, data)}
                          
                            >
                              Transaction Id:{data.txnId}
                            </a>
                          </h6>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={{ span: 24 }}>
                          <h6 className="font-normal">{data.description}</h6>
                        </Col>
                      </Row>
                      <Row className="main-data">
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Entered Date</b>
                          <h6 className="font-bold">
                            {enteredDate == "Invalid date" ? (
                              "-"
                            ) : (
                              <div> {enteredDate}</div>
                            )}
                          </h6>
                        </Col>
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Trade Date</b>
                          <h6 className="font-bold">
                            {tradeDate == "Invalid date" ? (
                              "-"
                            ) : (
                              <div> {tradeDate}</div>
                            )}
                          </h6>
                        </Col>
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Exchange Type</b>
                          <h6 className="font-bold">{data.exchangetype}</h6>
                        </Col>

                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Amount</b>
                          <h6 className="font-bold">
                            {!data.amount || data.amount == 0 ? (
                              "-"
                            ) : (
                              <div>
                                {"$" +
                                  parseFloat(data.amount).toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  )}
                              </div>
                            )}
                          </h6>
                        </Col>

                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Status</b>
                          <h6 className="font-bold">
                            {data.status.extDescription}
                          </h6>
                        </Col>
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Entered By</b>
                          <h6 className="font-bold">
                            {data.dpUserPrefix ||
                            data.dpUserFirstName ||
                            data.dpUserMiddleName ||
                            data.dpUserLastName ||
                            data.dpUserSuffix ? (
                              <div>
                                {data.dpUserPrefix} {data.dpUserFirstName}{" "}
                                {data.dpUserMiddleName} {data.dpUserLastName}{" "}
                                {data.dpUserSuffix}{" "}
                              </div>
                            ) : (
                              <div>{"-"}</div>
                            )}
                          </h6>
                        </Col>
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Recurring</b>
                          <h6 className="font-bold">
                            {data.isRecurring == "false" ||
                            !data.isRecurring ? (
                              "-"
                            ) : (
                              <div>
                                {" "}
                                <Icon type="sync" />
                              </div>
                            )}
                          </h6>
                        </Col>
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal" />
                          <h6 className="font-bold">{}</h6>
                        </Col>
                      </Row>
                    </AccountCardComponent>
                  );
                })}
              </div>
            ) : (
              <div className="noDataPlacement">
                <div>No exchanges have been made in the last 90 days.</div>
              </div>
            )}
          </TabPane>
          <TabPane tab={<div tabindex="0">Other Transactions</div>} key="4">
            {this.state.isOtherTransactionLoading == true ? (
              <div className="loader-position">
                <div>
                  <img alt="Loader" src={loader} className="mr-icon" />
                </div>
              </div>
            ) : threeMonthOtherData.length !== 0 ? (
              <div>
                <div className="table-fixed-link ac-link-navigator">
                  <TabFooter>
                    <a
                      data-test="otherTransactions"
                      onClick={() => this.navigateToTxn("otherTransactions")}
                      className="link-navigator tool-tip "
                      tabindex="0"
                    >
                      <span>VIEW OTHER TRANSACTIONS </span>
                      <div className="arrow-animation-blue" />{" "}
                    </a>

                    <NotifyText noMargin>
                      Transactions displayed above are from last 90 days
                    </NotifyText>
                  </TabFooter>
                </div>
                {threeMonthOtherData.map(data => {
                  let enteredDate = moment(
                    this.timeZoneConvertion(data.enteredDate)
                  ).format("L");
                  let tradeDate = moment(
                    this.timeZoneConvertion(data.tradeDate)
                  ).format("L");
                  return (
                    <AccountCardComponent>
                      <Row>
                        <Col md={{ span: 24 }} xs={{ span: 24 }}>
                          <h6 className="transaction-id">
                            <a
                              data-test="viewOtherTransaction"
                              onClick={() =>
                                this.viewOtherTransaction(data.txnId)
                              }
                            >
                              Transaction Id:{data.txnId}
                            </a>
                          </h6>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={{ span: 24 }}></Col>
                      </Row>

                      <Row className="main-data">
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Entered Date</b>
                          <h6 className="font-bold">
                            {enteredDate == "Invalid date" ? (
                              "-"
                            ) : (
                              <div> {enteredDate}</div>
                            )}
                          </h6>
                        </Col>
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Trade Date</b>
                          <h6 className="font-bold">
                            {tradeDate == "Invalid date" ? (
                              "-"
                            ) : (
                              <div> {tradeDate}</div>
                            )}
                          </h6>
                        </Col>
                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Type</b>
                          <h6 className="font-bold">{data.type}</h6>
                        </Col>

                        <Col md={{ span: 8 }} xs={{ span: 12 }}>
                          <b className="font-normal">Status</b>
                          <h6 className="font-bold">{data.status}</h6>
                        </Col>
                      </Row>
                    </AccountCardComponent>
                  );
                })}
              </div>
            ) : (
              <div className="noDataPlacement">
                <div>
                  No other transactions have been made in the last 90 days.
                </div>
              </div>
            )}
          </TabPane>
        </Tabs>
      </div>
    );
  }
}
TableTabs.propTypes = {
  isInvestmentLoading: PropTypes.bool,
  isGrantLoading: PropTypes.bool,
  investmentData: PropTypes.array,
  grant_data: PropTypes.array,
  contribution: PropTypes.array,
  isContributionLoading: PropTypes.bool,
  isAccountSummaryLoading: PropTypes.bool,
  accountSummaryBalance_data: PropTypes.array,
  isAllAccountSummaryLoading: PropTypes.bool,
  otherTransaction_data: PropTypes.array,
  isOtherTransactionLoading: PropTypes.bool
};

export const mapStateToProps = state => {
  return {
    ...accountSummaryDerivedStates(state.toJS())
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    selectHeader: data => dispatch(selectHeader(data))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableTabs);
